import React, { useEffect, useState, useCallback } from "react"; 
import {getdevicetagsModified, overviewHomeApi, postStatusDashboard, getdevicesMaintenance, getOverallMaintenanceUsers, getconfigMaintenance, saveMaintenanceDetails,postMaintenanceDashboard } from  "../../Restclient/datacollection";
import { useApiHandler } from '../../hooks/useApiHandler';
import { ErrorTypes } from '../../Restclient/axiosConfig';
import { Checkbox, Typography,Tooltip } from '@mui/material';
import { SimpleTreeView } from '@mui/x-tree-view/SimpleTreeView';
import { TreeItem } from '@mui/x-tree-view/TreeItem';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import CheckBoxOutlinedIcon from '@mui/icons-material/CheckBoxOutlined';
import TextField from '@mui/material/TextField';
import AssetTagsRetrievalModified from './AssetTagsRetrievalModified';
import { useSelector, useDispatch } from "react-redux";
import { updateplatjson } from "../../store/login_data";
import { getplantview } from "../../Restclient/datacollection";
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import CustomTableHeading from "../CommonComponents/CustomTableHeading";
import CustomActionButton from "../CommonComponents/CustomActionButton";
import CustomCancelButton from '../CommonComponents/CustomCancelButton';
import CustomDialogBox from "../CommonComponents/CustomDialogBox";
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import CustomMultiSelectwithDefaultOptions from "../CommonComponents/CustomMultiSelectwithDefaultOptions";
import LK_Delete from "../../images/LK_Delete";
import LK_Edit from "../../images/LK_Edit";
import LK_Loading from "../../images/LK_Loading.gif";
import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    IconButton,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    
  } from '@mui/material';
import CustomButton from "../CommonComponents/CustomButton";
import CustomTextField from "../CommonComponents/CustomTextField";
import Questionnaire from "./Questionnaire";
import CustomTableMetric from '../CommonComponents/CustomTableMetric';
import { set } from "date-fns";

// Utility to refresh plantview and update redux
function refreshPlantview(dispatch, orgid, projid) {
  getplantview(orgid, projid, (res) => {
    if (res && res.data) {
      dispatch(updateplatjson(res.data));
    }
  });
}

export default function OverviewDashboard(){
  // State for duplicate tag warning
  const [duplicateTagWarning, setDuplicateTagWarning] = useState(false);
  // Validation error for required tags
  const [validationError, setValidationError] = useState("");
    const[configDashboards, setConfigDashboards] = useState([]);
    const dispatch = useDispatch();
    const [loading,setLoading]=useState(1);
    const userdetails = useSelector((state) => state.logindata.userdetails)
    const [dashboardName, setDashboardname] = useState('')
    const projectname = useSelector((state) => state.mainpagedata.selectedprojectname);
    const[deleteDashboardFailed, setDashboardFailed] = useState(false);
    const[deleteDashboardSuccess, setDashboardSuccess] = useState(false);
    const [selectedTag, setSelectedTag] = useState({ tagid:'',tagname: '', tagunit: '', std_tagname: '', tagdatatype:'',projectid:''});
    const [focusedFieldKey, setFocusedFieldKey] = useState(null);
    const themechange = useSelector((state) => state.themedata.theme)
    const devicedetailsobject  = useSelector((state) => state.mainpagedata.devicedetailsobject)
    const [showAliasFlag, setShowAliasFlag] = useState(true);
    //const tagdetailsobject  = useSelector((state) => state.mainpagedata.tagdetailsobject)
    // API Handler with dialog control
    const { callApi } = useApiHandler({
        [ErrorTypes.NOT_FOUND]: 'Resource not found.',
        [ErrorTypes.FORBIDDEN]: 'You do not have permission to access this resource.',
        [ErrorTypes.SERVER_ERROR]: 'Server error occurred. Please try again.'
    });
    const [formConfig, setFormConfig] = useState({
        formName: '',
        energyTag: {
          value: '',
          tagid: '',
          tagname: '',
          tagunit: '',
          std_tagname: '',
          tagdatatype: '',
          projectid: '',
          enabled: false
        },
        xParameters: {
          count: 0,
          tags: []
        },
        yParameters: {
          count: 0,
          tags: []
        }
      });
    const[deleteMode, setDeleteMode] = useState(false);
    const [createdSucess, setCreatedSuccess] = useState(false);
    const [notCreatedSuccess, setNotCreatedSuccess] = useState(false);
    const[deleteDashboardObject, setDeleteDashboardObject] = useState(false);
    const[editMode, setEditMode] = useState(false);
    const[editDashboardObject, setEditDashboardObject] = useState(false);
    const [updatedSucess, setUpdatedSucess] = useState(false);
    const [notupdatedSucess, setNotUpdatedSucess] = useState(false);
    const [notCreatedMessage, setNotCreatedMessage] = useState('');
    const [assetdata,setAssetData] = useState(null);
    const [assetdataerror,setAssetDataError] = useState(false);
    const [selectedAsset, setSelectedAsset] = useState({asset_name:'', device_id:''});
     const tagdetailsobject = useSelector((state) => state.mainpagedata.tagdetailsobject);
    const [existingDeviceTagAlarmConfig, setExistingDeviceTagAlarmConfig] = useState(false);
    const [dashboardConfig, setDashboardConfig] = useState(() => {
        const config = {
            dashboardName: '',
            tags: []
        };
        for (let i = 0; i < 50; i++) {
            config.tags[i] = {
                value: '',
                tagid: '',
                tagname: '',
                tagunit: '',
                std_tagname: '',
                tagdatatype: '',
                projectid: '',
                enabled: false,
                aggregation: ''
            };
        }
        return config;
    });
    const selectedprojectname = useSelector((state) => state.mainpagedata.selectedprojectname);
    // Prevent duplicate warning from being re-triggered immediately after closing
    const duplicateWarningBlocked = React.useRef(false);

    // UseEffect to handle selected tag application to focused field
    useEffect(() => {
        if (duplicateTagWarning) {
          duplicateWarningBlocked.current = true;
          return;
        }
        // Only allow duplicate warning to be re-triggered after dialog is closed
        if (duplicateWarningBlocked.current && !duplicateTagWarning) {
          duplicateWarningBlocked.current = false;
          return;
        }

        if (focusedFieldKey && selectedTag?.tagname) {
          // Gather all assigned tagids except the current placeholder
          const assignedTagIds = new Set();
          // Always consider all prefilled tags (edit mode) for duplicate validation
          if (formConfig.energyTag.tagid && !(focusedFieldKey === 'energyTag')) {
            assignedTagIds.add(formConfig.energyTag.tagid);
          }
          formConfig.xParameters.tags.forEach((tag, idx) => {
            if (tag.tagid && !(focusedFieldKey === `xParameters[${idx}]`)) {
              assignedTagIds.add(tag.tagid);
            }
          });
          formConfig.yParameters.tags.forEach((tag, idx) => {
            if (tag.tagid && !(focusedFieldKey === `yParameters[${idx}]`)) {
              assignedTagIds.add(tag.tagid);
            }
          });
          // If selectedTag.tagid is already assigned elsewhere, show warning and ignore
          if (assignedTagIds.has(selectedTag.tagid)) {
            setDuplicateTagWarning(true);
            // Do not clear focusedFieldKey or selectedTag here; let user close dialog first
            return;
          }
            // Otherwise, assign as usual
            if (focusedFieldKey === 'energyTag') {
                setFormConfig(prev => ({
                    ...prev,
                    energyTag: {
                        value: selectedTag.tagname,
                        tagid: selectedTag.tagid,
                        tagname: selectedTag.tagname,
                        tagunit: selectedTag.tagunit,
                        std_tagname: selectedTag.std_tagname,
                        tagdatatype: selectedTag.tagdatatype,
                        projectid: selectedTag.projectid,
                        enabled: true
                    }
                }));
            } else if (focusedFieldKey.startsWith('xParameters[')) {
                const index = parseInt(focusedFieldKey.match(/\[(\d+)\]/)[1]);
                setFormConfig(prev => {
                    const updated = { ...prev };
                    updated.xParameters.tags[index] = {
                        value: selectedTag.tagname,
                        tagid: selectedTag.tagid,
                        tagname: selectedTag.tagname,
                        tagunit: selectedTag.tagunit,
                        std_tagname: selectedTag.std_tagname,
                        tagdatatype: selectedTag.tagdatatype,
                        projectid: selectedTag.projectid,
                        enabled: true
                    };
                    return updated;
                });
            } else if (focusedFieldKey.startsWith('yParameters[')) {
                const index = parseInt(focusedFieldKey.match(/\[(\d+)\]/)[1]);
                setFormConfig(prev => {
                    const updated = { ...prev };
                    updated.yParameters.tags[index] = {
                        value: selectedTag.tagname,
                        tagid: selectedTag.tagid,
                        tagname: selectedTag.tagname,
                        tagunit: selectedTag.tagunit,
                        std_tagname: selectedTag.std_tagname,
                        tagdatatype: selectedTag.tagdatatype,
                        projectid: selectedTag.projectid,
                        enabled: true
                    };
                    return updated;
                });
            }
            setFocusedFieldKey(null);
            setSelectedTag(null);
        }
    }, [selectedTag, focusedFieldKey, formConfig.energyTag, formConfig.xParameters.tags, formConfig.yParameters.tags, duplicateTagWarning]);

    // When dialog closes, also clear focusedFieldKey and selectedTag to allow new selection
    const handleCloseDuplicateTagWarning = () => {
      setDuplicateTagWarning(false);
      setFocusedFieldKey(null);
      setSelectedTag(null);
    };
    
      // Handle focus on tag input fields
      const handleTagFieldFocus = (fieldKey) => {
        // Only allow focusing a placeholder if a tag is already selected
        if (!selectedTag || !selectedTag.tagname) {
          // Optionally, show a warning or ignore silently
          return;
        }
        setFocusedFieldKey(fieldKey);
        console.log("Focused field:", fieldKey);
      };

      const assetcallback = (res) => {
        if(res.success == true){
            setAssetData({devices: res.devices});
        }else{
            setAssetData({devices: {}});
        }
    };

    useEffect(() => {
          getdevicetagsModified(assetcallback)
        }, [selectedprojectname]);

    // Handle tag field value change
    const handleTagFieldChange = (fieldKey, value) => {
    if (fieldKey === 'energyTag') {
      setFormConfig(prev => ({
        ...prev,
        energyTag: {
          ...prev.energyTag,
          value: value
        }
      }));
    } else if (fieldKey.startsWith('xParameters[')) {
      const index = parseInt(fieldKey.match(/\[(\d+)\]/)[1]);
      setFormConfig(prev => {
        const updated = { ...prev };
        updated.xParameters.tags[index] = {
          ...updated.xParameters.tags[index],
          value: value
        };
        return updated;
      });
    } else if (fieldKey.startsWith('yParameters[')) {
      const index = parseInt(fieldKey.match(/\[(\d+)\]/)[1]);
      setFormConfig(prev => {
        const updated = { ...prev };
        updated.yParameters.tags[index] = {
          ...updated.yParameters.tags[index],
          value: value
        };
        return updated;
      });
    }
    setSelectedTag(null); // Clear selected tag on manual input
  };

    // Handle aggregation change for a tag
    const handleAggregationChange = (index, aggValue) => {
        setDashboardConfig(prev => {
            const updated = { ...prev };
            updated.tags[index] = {
                ...updated.tags[index],
                aggregation: aggValue
            };
            return updated;
        });
    }

    const handleXParameterCountChange = (count) => {
    const newCount = Math.max(0, Math.min(20, count));
    setFormConfig(prev => {
      const newTags = [...prev.xParameters.tags];
      
      // Add new empty tags if count increased
      while (newTags.length < newCount) {
        newTags.push({
          value: '',
          tagid: '',
          tagname: '',
          tagunit: '',
          std_tagname: '',
          tagdatatype: '',
          projectid: '',
          enabled: false
        });
      }
      
      // Remove tags if count decreased
      while (newTags.length > newCount) {
        newTags.pop();
      }

      return {
        ...prev,
        xParameters: {
          count: newCount,
          tags: newTags
        }
      };
    });
  };

   const handleCloseCreateDashboard = useCallback(() => {
        setCreatedSuccess(false)
    }, []);

    const handleCloseNotCreateDashboard = useCallback(() => {
        setNotCreatedSuccess(false)
    }, []);
    
  // Handle Department parameter count change
  const handleYParameterCountChange = (count) => {
    const newCount = Math.max(0, Math.min(20, count));
    setFormConfig(prev => {
      const newTags = [...prev.yParameters.tags];
      
      // Add new empty tags if count increased
      while (newTags.length < newCount) {
        newTags.push({
          value: '',
          tagid: '',
          tagname: '',
          tagunit: '',
          std_tagname: '',
          tagdatatype: '',
          projectid: '',
          enabled: false
        });
      }
      
      // Remove tags if count decreased
      while (newTags.length > newCount) {
        newTags.pop();
      }

      return {
        ...prev,
        yParameters: {
          count: newCount,
          tags: newTags
        }
      };
    });
  };

    // Handle form name change
  function handleFormNameChange(value) {
    setFormConfig(prev => ({
      ...prev,
      formName: value
    }));
  }

    // Handle tag field clear
    const handleClearTagField = (fieldKey) => {
      if (fieldKey === 'energyTag') {
        setFormConfig(prev => ({
          ...prev,
          energyTag: {
            value: '',
            tagid: '',
            tagname: '',
            tagunit: '',
            std_tagname: '',
            tagdatatype: '',
            projectid: '',
            enabled: false
          }
        }));
      } else if (fieldKey.startsWith('xParameters[')) {
        const index = parseInt(fieldKey.match(/\[(\d+)\]/)[1]);
        setFormConfig(prev => {
          const updated = { ...prev };
          updated.xParameters.tags[index] = {
            value: '',
            tagid: '',
            tagname: '',
            tagunit: '',
            std_tagname: '',
            tagdatatype: '',
            projectid: '',
            enabled: false
          };
          return updated;
        });
      } else if (fieldKey.startsWith('yParameters[')) {
        const index = parseInt(fieldKey.match(/\[(\d+)\]/)[1]);
        setFormConfig(prev => {
          const updated = { ...prev };
          updated.yParameters.tags[index] = {
            value: '',
            tagid: '',
            tagname: '',
            tagunit: '',
            std_tagname: '',
            tagdatatype: '',
            projectid: '',
            enabled: false
          };
          return updated;
        });
      }
    }

    function handledashboardNameChange(value){
        setDashboardname(value)
        // Also update the dashboard config
        setDashboardConfig(prev => ({
            ...prev,
            dashboardName: value
        }));
    }

    function handleDelete(currentDashboard) {
        setDeleteDashboardObject(currentDashboard)
        setDeleteMode(true) 
        // Add your edit logic here 
    }

    function handleConfirmDialogDeleteDashboard(){
            
            // if(userdetails?.Projectid == "All"){
            //     deletePQDashboard(deleteDashboardObject?.dashboard_pro, projectname, userdetails.Organizationid,deletePQDashboardcallback)
            // }else{
            //     deletePQDashboard(deleteDashboardObject?.dashboard_pro, userdetails.Projectid, userdetails.Organizationid,deletePQDashboardcallback)
            // }
          
            // console.log("handleConfirmDialogDeleteDashboard clicked for dashboard", deleteDashboardObject);
            setDeleteMode(false) 
    }

    function handleCloseDeleteDashboard(){
        setDeleteMode(false) 
    }

    async function handleConfirmDialogDeleteDashboard(){
        
        await callApi(
          () => overviewHomeApi.deleteDashboard(
            deleteDashboardObject.dashboard_pro,
            deleteDashboardObject.Projectid,
            deleteDashboardObject.Organizationid
          ),
          {
            showDialog: false,
            hideDialogOnStatusCodes: [404],
            showDialogOnCatch: false,
            useBackendMessage: true,
            onSuccess: (response) => {
              if (response.data.success && response.data?.data && response.data?.data?.data) {
                setConfigDashboards(response.data?.data?.data);
                setDashboardSuccess(true);
                // Refresh plantview after successful delete
                //refreshPlantview(dispatch, userdetails?.Organizationid, userdetails?.Projectid === "All" ? projectname : userdetails?.Projectid);
                getplantview(userdetails?.Organizationid, userdetails?.Projectid === "All" ? selectedprojectname : userdetails?.Projectid, (res) => {
                                                console.log("res in refreshPlantview StatusTableDashboard",res)
                                                if (res && res.plantview) {
                                                    dispatch(updateplatjson(res.plantview));
                                                }
                                            });
              } else {
                setDashboardFailed(true);
                setNotCreatedMessage(response.data.message || "Failed to delete dashboard.");
              }
              setLoading(0);
            },
            onError: (error) => {
              setDashboardFailed(true);
              setNotCreatedMessage(error?.message || "Failed to delete dashboard.");
              setLoading(0);
            },
            onCatchError: (error, errorInfo) => {
              setNotCreatedMessage(error?.message || "Unexpected error deleting dashboard.");
              setDashboardFailed(true);
              setLoading(0);
            }
          }
        );
        setDeleteMode(false);
    }
    
    function handleDelete(currentDashboard) {
        
        setDeleteDashboardObject(currentDashboard)
        setDeleteMode(true) 
        // Add your edit logic here 
    }

    function handleCloseDeleteDashboard(){
        setDeleteMode(false) 
    }

    function handleCloseDeleteDashboardFailed(){
        setDashboardFailed(false) 
    }

    function handleCloseDeleteDashboardSuccess(){
        setDashboardSuccess(false) 
    }

    // Render energy tag configuration field
  const renderEnergyTagField = () => {
    const tag = formConfig.energyTag;
    return (
      <div style={{ 
        display: 'flex', 
        alignItems: 'center', 
        gap: '10px',
        padding: '15px',
        border: '1px solid #ccc',
        borderRadius: '8px',
        backgroundColor: tag.enabled ? 'rgba(76, 175, 80, 0.1)' : 'transparent'
      }}>
        <span style={{ 
          minWidth: '120px', 
          fontSize: '16px',
          fontWeight: tag.enabled ? 600 : 400,
          color: '#666'
        }}>
          Energy Tag:
        </span>
        <Tooltip
          title={(() => {
            const tagObj = tagdetailsobject[tag.tagid];
            const deviceName = tagObj && tagObj.DeviceID && devicedetailsobject[tagObj.DeviceID] ? devicedetailsobject[tagObj.DeviceID].Name : "";
            const alias = tagObj && tagObj.Alias ? tagObj.Alias : (tag.value != '')?"(No Alias)":'';
            const name = tagObj && tagObj.Name ? tagObj.Name : (tag.value != '')?"(No Name)":'';
            return `${deviceName}: ${showAliasFlag ? alias : name}` || "Select tag";
          })()}
          arrow
          placement="top"
        >
          <TextField
            className="textfield"
            variant="standard"
            type="text"
            size="small"
            value={(() => {
              const tagObj = tagdetailsobject[tag.tagid];
              const deviceName = tagObj && tagObj.DeviceID && devicedetailsobject[tagObj.DeviceID] ? devicedetailsobject[tagObj.DeviceID].Name : "";
              const alias = tagObj && tagObj.Alias ? tagObj.Alias : (tag.value != '')?"(No Alias)":'';
              const name = tagObj && tagObj.Name ? tagObj.Name : (tag.value != '')?"(No Name)":'';
              return `${deviceName}: ${showAliasFlag ? alias : name}`;
            })()}
            placeholder="Select tag"
            onFocus={() => handleTagFieldFocus('energyTag')}
            onChange={(e) => handleTagFieldChange('energyTag', e.target.value)}
            onKeyDown={e => e.preventDefault()}
            sx={{
              marginLeft:"16px",
              marginTop:"0px",
              fontSize:"16px",
              fontFamily:"Roboto",
              marginLeft:"14px",
              '& .MuiInputBase-input:focus': { color: '#008CD7' },
              '& .MuiInputBase-root': {
                fontFamily: 'Roboto',
                fontSize: '16px',
                fontWeight: '700',
                color: themechange === 'light' ? '#3C3C3C' : '#FFFFFF'
              },
              '& .MuiInputBase-root::before': {
                  borderBottom: `1px solid ${themechange === 'light' ? '#3C3C3C' : '#FFFFFF'}`
              },
              "& .MuiInput-underline:hover:not(.Mui-disabled):before": {
                  borderBottom: '2px solid #008CD7',
              },
              '& .MuiInputBase-root::after': {
                  borderBottom: '2px solid #008CD7',
              },
              }}
          />
          </Tooltip>
        {(tag.enabled || tag.tagid || tag.tagname) && (
          <>
            <span style={{
              backgroundColor: '#1976d2',
              color: 'white',
              padding: '4px 8px',
              borderRadius: '12px',
              fontSize: '12px'
            }}>
              {tag.tagunit}
            </span>
            <button
              onClick={() => handleClearTagField('energyTag')}
              style={{
                backgroundColor: '#f44336',
                color: 'white',
                border: 'none',
                borderRadius: '4px',
                padding: '6px 10px',
                cursor: 'pointer',
                fontSize: '16px'
              }}
            >
              ×
            </button>
          </>
        )}
      </div>
    );
  };

  
  // Render Asset parameter configuration fields
  const renderXParameterFields = () => {
    return (
      <div style={{ marginTop: '20px' }}>
          <Typography sx={{fontSize:"16px",fontFamily:"Roboto",color:'var(--SecondaryText)', marginBottom: '15px',fontWeight: 400, marginLeft:"0px",marginTop:"6px", textAlign:"left"}}>Top Guzzlers: Configure Assets Consumption({formConfig.xParameters.tags.filter(tag => tag.enabled).length} / {formConfig.xParameters.count} configured)</Typography>
        
          <div style={{ marginBottom: '20px', display: 'flex', alignItems: 'center', gap: '10px' }}>
              <Typography sx={{fontSize:"16px",fontFamily:"Roboto",color:'var(--SecondaryText)', marginBottom: '15px',fontWeight: 400, marginLeft:"0px",marginTop:"6px", textAlign:"left"}}>Number of Assets:</Typography>
              <button 
                onClick={() => handleXParameterCountChange(formConfig.xParameters.count - 1)}
                disabled={formConfig.xParameters.count === 0}
                style={{
                  backgroundColor: '#008cd7',
                  color: 'white',
                  border: 'none',
                  borderRadius: '4px',
                  padding: '5px 10px',
                  cursor: 'pointer',
                  opacity: formConfig.xParameters.count === 0 ? 0.5 : 1
                }}
              >
                -
              </button>
              <TextField
                className="textfield"
                variant="standard"
                type="number"
                value={formConfig.xParameters.count}
                onChange={(e) => handleXParameterCountChange(parseInt(e.target.value) || 0)}
                min="0"
                max="20"
                 sx={{
                    marginLeft:"16px",
                    marginTop:"0px",
                    fontSize:"16px",
                    fontFamily:"Roboto",
                    marginLeft:"14px",
                    '& .MuiInputBase-input:focus': { color: '#008CD7' },
                    '& .MuiInputBase-root': {
                        fontFamily: 'Roboto',
                        fontSize: '16px',
                        fontWeight: '700',
                        color: themechange === 'light' ? '#3C3C3C' : '#FFFFFF'
                    },
                    '& .MuiInputBase-root::before': {
                        borderBottom: `1px solid ${themechange === 'light' ? '#3C3C3C' : '#FFFFFF'}`
                    },
                    "& .MuiInput-underline:hover:not(.Mui-disabled):before": {
                        borderBottom: '2px solid #008CD7',
                    },
                    '& .MuiInputBase-root::after': {
                        borderBottom: '2px solid #008CD7',
                    },
                    }}
              />
              <button 
                onClick={() => handleXParameterCountChange(formConfig.xParameters.count + 1)}
                disabled={formConfig.xParameters.count >= 20}
                style={{
                  backgroundColor: '#008cd7',
                  color: 'white',
                  border: 'none',
                  borderRadius: '4px',
                  padding: '5px 10px',
                  cursor: 'pointer',
                  opacity: formConfig.xParameters.count >= 20 ? 0.5 : 1
                }}
              >
                +
              </button>
          </div>

        <div style={{ display: 'grid', gridTemplateColumns: '1fr', gap: '5px', maxHeight: '300px', overflowY: 'auto' }}>
          {formConfig.xParameters.tags.map((tag, index) => (
            <div key={index} style={{ 
              display: 'flex', 
              alignItems: 'center', 
              gap: '10px',
              padding: '10px',
              border: '1px solid #ccc',
              borderRadius: '8px',
              backgroundColor: tag.enabled ? 'rgba(25, 118, 210, 0.1)' : 'transparent'
            }}>
              <span style={{ 
                minWidth: '80px', 
                fontSize: '14px',
                fontWeight: tag.enabled ? 600 : 400,
                color: '#666'
              }}>
                Asset {index + 1} Tag:
              </span>
            <Tooltip
              title={(() => {
                const tagObj = tagdetailsobject[tag.tagid];
                const deviceName = tagObj && tagObj.DeviceID && devicedetailsobject[tagObj.DeviceID] ? devicedetailsobject[tagObj.DeviceID].Name : "";
                const alias = tagObj && tagObj.Alias ? tagObj.Alias : (tag.value !== '' ? "(No Alias)" : '');
                const name = tagObj && tagObj.Name ? tagObj.Name : (tag.value !== '' ? "(No Name)" : '');
                return `${deviceName}: ${showAliasFlag ? alias : name}` || "Select tag";
              })()}
              arrow
              placement="top"
            >
              <TextField
                className="textfield"
                variant="standard"
                type="text"
                value={(() => {
                  const tagObj = tagdetailsobject[tag.tagid];
                  const deviceName = tagObj && tagObj.DeviceID && devicedetailsobject[tagObj.DeviceID] ? devicedetailsobject[tagObj.DeviceID].Name : "";
                  const alias = tagObj && tagObj.Alias ? tagObj.Alias : (tag.value !== '' ? "(No Alias)" : '');
                  const name = tagObj && tagObj.Name ? tagObj.Name : (tag.value !== '' ? "(No Name)" : '');
                  return `${deviceName}: ${showAliasFlag ? alias : name}`;
                })()}
                placeholder="Select tag"
                onFocus={() => handleTagFieldFocus(`xParameters[${index}]`)}
                onChange={(e) => handleTagFieldChange(`xParameters[${index}]`, e.target.value)}
                onKeyDown={e => e.preventDefault()}
                 sx={{
                marginLeft:"16px",
                marginTop:"0px",
                fontSize:"16px",
                fontFamily:"Roboto",
                marginLeft:"14px",
                '& .MuiInputBase-input:focus': { color: '#008CD7' },
                '& .MuiInputBase-root': {
                    fontFamily: 'Roboto',
                    fontSize: '16px',
                    fontWeight: '700',
                    color: themechange === 'light' ? '#3C3C3C' : '#FFFFFF'
                },
                '& .MuiInputBase-root::before': {
                    borderBottom: `1px solid ${themechange === 'light' ? '#3C3C3C' : '#FFFFFF'}`
                },
                "& .MuiInput-underline:hover:not(.Mui-disabled):before": {
                    borderBottom: '2px solid #008CD7',
                },
                '& .MuiInputBase-root::after': {
                    borderBottom: '2px solid #008CD7',
                },
                }}
          />
          </Tooltip>
              {(tag.enabled || tag.tagid || tag.tagname) && (
                <>
                  <span style={{
                    backgroundColor: '#1976d2',
                    color: 'white',
                    padding: '4px 8px',
                    borderRadius: '12px',
                    fontSize: '12px'
                  }}>
                    {tag.tagunit}
                  </span>
                  <button
                    onClick={() => handleClearTagField(`xParameters[${index}]`)}
                    style={{
                      backgroundColor: '#f44336',
                      color: 'white',
                      border: 'none',
                      borderRadius: '4px',
                      padding: '6px 10px',
                      cursor: 'pointer',
                      fontSize: '16px'
                    }}
                  >
                    ×
                  </button>
                </>
              )}
            </div>
          ))}
        </div>
      </div>
    );
  };

  // Render Department parameter configuration fields
  const renderYParameterFields = () => {
    return (
      <div style={{ marginTop: '20px' }}>
        <Typography sx={{fontSize:"16px",fontFamily:"Roboto",color:'var(--SecondaryText)', marginBottom: '15px',fontWeight: 400, marginLeft:"0px",marginTop:"6px", textAlign:"left"}}>Top Guzzlers: Configure Departments Consumption ({formConfig.yParameters.tags.filter(tag => tag.enabled).length} / {formConfig.yParameters.count} configured)</Typography>
        
        <div style={{ marginBottom: '20px', display: 'flex', alignItems: 'center', gap: '10px' }}>
          <Typography sx={{fontSize:"16px",fontFamily:"Roboto",color:'var(--SecondaryText)', marginBottom: '15px',fontWeight: 400, marginLeft:"0px",marginTop:"6px", textAlign:"left"}}>Number of Departments:</Typography>
          <button 
            onClick={() => handleYParameterCountChange(formConfig.yParameters.count - 1)}
            disabled={formConfig.yParameters.count === 0}
            style={{
              backgroundColor: '#008cd7',
              color: 'white',
              border: 'none',
              borderRadius: '4px',
              padding: '5px 10px',
              cursor: 'pointer',
              opacity: formConfig.yParameters.count === 0 ? 0.5 : 1
            }}
          >
            -
          </button>
          <TextField
            className="textfield"
            variant="standard"
            type="number"
            value={formConfig.yParameters.count}
            onChange={(e) => handleYParameterCountChange(parseInt(e.target.value) || 0)}
            min="0"
            max="20"
             sx={{
                marginLeft:"16px",
                marginTop:"0px",
                fontSize:"16px",
                fontFamily:"Roboto",
                marginLeft:"14px",
                '& .MuiInputBase-input:focus': { color: '#008CD7' },
                '& .MuiInputBase-root': {
                    fontFamily: 'Roboto',
                    fontSize: '16px',
                    fontWeight: '700',
                    color: themechange === 'light' ? '#3C3C3C' : '#FFFFFF'
                },
                '& .MuiInputBase-root::before': {
                    borderBottom: `1px solid ${themechange === 'light' ? '#3C3C3C' : '#FFFFFF'}`
                },
                "& .MuiInput-underline:hover:not(.Mui-disabled):before": {
                    borderBottom: '2px solid #008CD7',
                },
                '& .MuiInputBase-root::after': {
                    borderBottom: '2px solid #008CD7',
                },
                }}
          />
          <button 
            onClick={() => handleYParameterCountChange(formConfig.yParameters.count + 1)}
            disabled={formConfig.yParameters.count >= 20}
            style={{
              backgroundColor: '#008cd7',
              color: 'white',
              border: 'none',
              borderRadius: '4px',
              padding: '5px 10px',
              cursor: 'pointer',
              opacity: formConfig.yParameters.count >= 20 ? 0.5 : 1
            }}
          >
            +
          </button>
        </div>

        <div style={{ display: 'grid', gridTemplateColumns: '1fr', gap: '10px', maxHeight: '300px', overflowY: 'auto' }}>
          {formConfig.yParameters.tags.map((tag, index) => (
            <div key={index} style={{ 
              display: 'flex', 
              alignItems: 'center', 
              gap: '10px',
              padding: '10px',
              border: '1px solid #ccc',
              borderRadius: '8px',
              backgroundColor:tag.enabled ? 'rgba(25, 118, 210, 0.1)' : 'transparent'
            }}>
              <span style={{ 
                minWidth: '80px', 
                fontSize: '14px',
                fontWeight: tag.enabled ? 600 : 400,
                color: '#666'
              }}>
                Department {index + 1} Tag:
              </span>
              <Tooltip
                title={(() => {
                  const tagObj = tagdetailsobject[tag.tagid];
                  const deviceName = tagObj && tagObj.DeviceID && devicedetailsobject[tagObj.DeviceID] ? devicedetailsobject[tagObj.DeviceID].Name : "";
                  const alias = tagObj && tagObj.Alias ? tagObj.Alias : (tag.value != '')?"(No Alias)":'';
                  const name = tagObj && tagObj.Name ? tagObj.Name : (tag.value != '')?"(No Name)":'';
                  return `${deviceName}: ${showAliasFlag ? alias : name}` || "Select tag";
                })()}
                arrow
                placement="top"
              >
              <TextField
                className="textfield"
                variant="standard"
                type="text"
                value={(() => {
                  const tagObj = tagdetailsobject[tag.tagid];
                  const deviceName = tagObj && tagObj.DeviceID && devicedetailsobject[tagObj.DeviceID] ? devicedetailsobject[tagObj.DeviceID].Name : "";
                  const alias = tagObj && tagObj.Alias ? tagObj.Alias :(tag.value != '')?"(No Alias)":'';
                  const name = tagObj && tagObj.Name ? tagObj.Name : (tag.value != '')?"(No Name)":'';
                  return `${deviceName}: ${showAliasFlag ? alias : name}`;
                  })()}
                  placeholder="Select tag"
                  onFocus={() => handleTagFieldFocus(`yParameters[${index}]`)}
                  onChange={(e) => handleTagFieldChange(`yParameters[${index}]`, e.target.value)}
                  onKeyDown={e => e.preventDefault()}
                   sx={{
                  marginLeft:"16px",
                  marginTop:"0px",
                  fontSize:"16px",
                  fontFamily:"Roboto",
                  marginLeft:"14px",
                  '& .MuiInputBase-input:focus': { color: '#008CD7' },
                  '& .MuiInputBase-root': {
                    fontFamily: 'Roboto',
                    fontSize: '16px',
                    fontWeight: '700',
                    color: themechange === 'light' ? '#3C3C3C' : '#FFFFFF'
                  },
                  '& .MuiInputBase-root::before': {
                    borderBottom: `1px solid ${themechange === 'light' ? '#3C3C3C' : '#FFFFFF'}`
                  },
                  "& .MuiInput-underline:hover:not(.Mui-disabled):before": {
                    borderBottom: '2px solid #008CD7',
                  },
                  '& .MuiInputBase-root::after': {
                    borderBottom: '2px solid #008CD7',
                  },
                  }}
                />
          </Tooltip>
              {(tag.enabled || tag.tagid || tag.tagname) && (
                <>
                  <span style={{
                   backgroundColor: '#1976d2',
                    color: 'white',
                    padding: '4px 8px',
                    borderRadius: '12px',
                    fontSize: '12px'
                  }}>
                    {tag.tagunit}
                  </span>
                  <button
                    onClick={() => handleClearTagField(`yParameters[${index}]`)}
                    style={{
                      backgroundColor: '#f44336',
                      color: 'white',
                      border: 'none',
                      borderRadius: '4px',
                      padding: '6px 10px',
                      cursor: 'pointer',
                      fontSize: '16px'
                    }}
                  >
                    ×
                  </button>
                </>
              )}
            </div>
          ))}
        </div>
      </div>
    );
  };

    function handleEdit(currentDashboard){
        
        let allTags = [];
        var tagprops = currentDashboard.DashboardJSON.widgetlist[0].props.extended.tagprops;
        var tagpropsFunnel = currentDashboard.DashboardJSON.widgetlist[3].props.extended.tagprops;
        var currentFormName = currentDashboard.Dashboardname;
        var currentEnergyTag = {
          value: tagdetailsobject[tagprops[0].tagid]?.Alias || '',
          tagid: tagprops[0].tagid,
          tagname: tagdetailsobject[tagprops[0].tagid]?.Alias || '',
          tagunit: tagdetailsobject[tagprops[0].tagid]?.Unit || '',
          std_tagname: tagdetailsobject[tagprops[0].tagid]?.Alias || '',
          tagdatatype: tagdetailsobject[tagprops[0].tagid]?.Unit || '',
          projectid: projectname,
          enabled: false
        };

        let xparameters = [];
        let xparameterscount = 0;
        let yparameters = [];
        let yparameterscount = 0;

        for(let i=0;i<tagpropsFunnel.length;i++){
            if(tagpropsFunnel[i].optionname == "option1"){
                xparameters.push({
                    value: tagdetailsobject[tagpropsFunnel[i].tagid]?.Alias || '',
                    tagid: tagpropsFunnel[i].tagid,
                    tagname: tagdetailsobject[tagpropsFunnel[i].tagid]?.Alias || '',
                    tagunit: tagdetailsobject[tagpropsFunnel[i].tagid]?.Unit || '',
                    std_tagname: tagdetailsobject[tagpropsFunnel[i].tagid]?.Alias || '',
                    tagdatatype: tagdetailsobject[tagpropsFunnel[i].tagid]?.Unit || '',
                    projectid: projectname,
                    enabled: false
                });
                xparameterscount++;
            }else if(tagpropsFunnel[i].optionname == "option2"){
                yparameters.push({
                    value: tagdetailsobject[tagpropsFunnel[i].tagid]?.Alias || '',
                    tagid: tagpropsFunnel[i].tagid,
                    tagname: tagdetailsobject[tagpropsFunnel[i].tagid]?.Alias || '',
                    tagunit: tagdetailsobject[tagpropsFunnel[i].tagid]?.Unit || '',
                    std_tagname: tagdetailsobject[tagpropsFunnel[i].tagid]?.Alias || '',
                    tagdatatype: tagdetailsobject[tagpropsFunnel[i].tagid]?.Unit || '',
                    projectid: projectname,
                    enabled: false
                });
                yparameterscount++;
            }
        }
        
        let formObject = {
            formName: currentFormName,
            energyTag: currentEnergyTag,
            xParameters: {
                count: xparameterscount,
                tags: xparameters
            },
            yParameters: {
                count: yparameterscount,
                tags: yparameters
            }
        }

        setFormConfig(formObject);
        const config = {
            dashboardName: dashboardConfig.dashboardName,
            tags: allTags
        };
        setDashboardConfig(config);
        setEditDashboardObject(currentDashboard);
        setEditMode(true);
    }

    
        function handleCancelUpdatedChange(){
          // Reset all relevant state to initial values
          setEditMode(false);
          setFormConfig({
            formName: '',
            energyTag: {
              value: '',
              tagid: '',
              tagname: '',
              tagunit: '',
              std_tagname: '',
              tagdatatype: '',
              projectid: '',
              enabled: false
            },
            xParameters: {
              count: 0,
              tags: []
            },
            yParameters: {
              count: 0,
              tags: []
            }
          });
          
          setFocusedFieldKey(null);
          setSelectedTag({ tagid:'',tagname: '', tagunit: '', std_tagname: '', tagdatatype:'',projectid:'' });
          setSelectedAsset({asset_name:'', device_id:''});
          setExistingDeviceTagAlarmConfig(false);
          setShowAliasFlag(true);
        }
    
        
        
        function handleCloseUpdateDashboard(){
            setUpdatedSucess(false)
        }
    
        function handleCloseNotUpdateDashboard(){
            setNotUpdatedSucess(false)
        }

          const handleSaveUpdatedChange = async () => {
                // Validation: Energy Tag and at least 2 asset tags required
                const filteredEnergyTag = (formConfig.energyTag.tagid && formConfig.energyTag.tagname) ? formConfig.energyTag : null;
                const filteredXParameters = formConfig.xParameters.tags.filter(tag => tag.tagid && tag.tagname);
                const filteredYParameters = formConfig.yParameters.tags.filter(tag => tag.tagid && tag.tagname);
                const assetTagCount = filteredXParameters.length + filteredYParameters.length;
                if (!filteredEnergyTag) {
                  setValidationError("Energy Tag is required.");
                  return;
                }
                if (assetTagCount < 2) {
                  setValidationError("At least 2 asset tags are required.");
                  return;
                }
                setValidationError("");
                if (editDashboardObject && editDashboardObject?.dashboard_pro) { 
                  // Save the complete form configuration
                    const configuredData = {
                      formName: formConfig.formName,
                      energyTag: filteredEnergyTag,
                      xParameters: filteredXParameters,
                      yParameters: filteredYParameters
                    };
                    const payload = {
                      dashboardName: formConfig.formName,
                      configuredData: configuredData,
                      projectId: editDashboardObject?.Projectid,
                      organizationId: editDashboardObject?.Organizationid,
                      action:"UPDATE",
                      dashboard_pro:editDashboardObject?.dashboard_pro,
                    };
                    await callApi(
                      () => overviewHomeApi.updateDashboard(payload),
                      {
                        showDialog: false,
                        hideDialogOnStatusCodes: [404],
                        showDialogOnCatch: false,
                        useBackendMessage: true,
                        onSuccess: (response) => {
                          if (response.data.success && response.data.data && response.data.data?.data) {
                            setConfigDashboards(response.data.data.data);
                            setUpdatedSucess(true);
                          } else {
                            setNotUpdatedSucess(true);
                            setNotCreatedMessage(response.data.message || "Failed to update dashboard.");
                          }
                        },
                        onError: (error) => {
                          setNotUpdatedSucess(true);
                          setNotCreatedMessage(error?.message || "Failed to update dashboard.");
                        },
                        onCatchError: (error, errorInfo) => {
                          setNotCreatedMessage(error?.message || "Failed to update dashboard due to unexpected error.");
                          setNotUpdatedSucess(true);
                        }
                      }
                    );
                }
              };

    useEffect(() => {
            const fetchDashboards = async () => {
              
                if(selectedprojectname) {
                    
                    await callApi(
                        () => overviewHomeApi.getDashboards(),
                        {
                            showDialog: false,
                            hideDialogOnStatusCodes: [404],
                            showDialogOnCatch: false,
                            useBackendMessage: true,
                            onSuccess: (response) => {
                                
                                // Axios response: response.data contains the server's JSON response
                                if (response.data.success && response.data.data && response.data.data.data) {
                                    
                                    setConfigDashboards(response.data.data.data);
                                } else {
                                    
                                    setConfigDashboards([]);
                                }
                                setLoading(0);
                            },
                            onError: (error) => {
                                
                                setConfigDashboards([]);
                                setLoading(0);
                            },
                            onCatchError: (error, errorInfo) => {
                                
                                setConfigDashboards([]);
                                setLoading(0);
                            }
                        }
                    );
                    
                }else {
                    console.error(" Project name is not available:",selectedprojectname);
                }
            };
            
            fetchDashboards();
        },[selectedprojectname]);

    return (
      <Box sx={{boxSizing:"border-box",padding:"8px",background:'var(--PrimaryBackground)',height:'calc(93%)',marginBottom:"0px",overflow:"hidden"}}>
        {validationError && (
          <div style={{ color: '#f44336', fontWeight: 600, marginBottom: 12, fontSize: 16 }}>
            {validationError}
          </div>
        )}
        {/* Duplicate tag warning dialog */}
        <CustomDialogBox
          dialogTitle={"Duplicate Tag Assignment"}
          dialogText={"You cannot assign the same tag to multiple placeholders. Please select a different tag."}
          openDialog={duplicateTagWarning}
          handleCloseDialog={handleCloseDuplicateTagWarning}
          handleConfirmDialog={handleCloseDuplicateTagWarning}
          confirmText={"Ok"}
          cancelText={"Cancel"}
          type={"Error"}
        />
            {(editMode == false) && <>
                <Typography sx={{fontSize:"16px",fontFamily:"Roboto",color:'var(--SecondaryText)',fontWeight: 400, marginLeft:"0px",marginTop:"6px", textAlign:"left"}}>Dashboards List</Typography>
                {loading===0 ? (<TableContainer component={Paper} sx={{ width: '100%', maxHeight:"calc(100% - 40px)",paddingLeft:'0px',backgroundColor:'var(--secondary-backgroundLK)',paddingRight:'0px', overflow:'auto' }} elevation={0}>
                    <Table sx={{ width: '100%' }} size="large" stickyHeader>
                        <TableHead>
                            <TableRow sx={{border:"0px"}}>
                                <TableCell align="left" sx={{ fontSize:"12px",fontWeight:400,color:"var(--grey-variation-tableLK)",backgroundColor:'var(--secondary-backgroundLK)'}}><CustomTableHeading children={'Dashboards'} /></TableCell>
                                <TableCell align="left" sx={{ fontSize:"12px",fontWeight:400,color:"var(--grey-variation-tableLK)",paddingLeft:4.5,backgroundColor:'var(--secondary-backgroundLK)'}}><CustomTableHeading children={'Edit'} /></TableCell>
                                <TableCell align="left" sx={{ fontSize:"12px",fontWeight:400,color:"var(--grey-variation-tableLK)",paddingLeft:4.5,backgroundColor:'var(--secondary-backgroundLK)'}}><CustomTableHeading children={'Delete'} /></TableCell>
                                {/*<TableCell align="left" sx={{ fontSize:"12px",fontWeight:400,color:"var(--grey-variation-tableLK)",paddingLeft:4.5}}><CustomTableHeading children={'Clone'} /></TableCell>*/}
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {((Array.isArray(configDashboards)) && (configDashboards.length != 0)) ? configDashboards.map((currentDashboard, index) => (
                                <TableRow key={currentDashboard.id} 
                                    sx={{
                                        '&:last-child td, &:last-child th': { border: 0 },
                                        height:"9px",
                                        '& > *': { borderBottom: "1px solid var(--table-boarder-line)" },
                                        cursor: 'pointer',
                                        '&:hover': {
                                            backgroundColor: 'rgba(0, 140, 215, 0.08)',
                                        },
                                        '&:active': {
                                            backgroundColor: 'rgba(0, 140, 215, 0.15)',
                                        }
                                    }}>
                                    {console.log("currentDashboard---///",currentDashboard)}
                                    <TableCell component="th" scope="row" sx={{ fontSize:"12px",fontWeight:400,color:'var(--grey-variation-tablerowsLK)',paddingTop:"5px",paddingBottom:"5px"}}><CustomTableMetric children={ currentDashboard.Dashboardname }/></TableCell>
                                    <TableCell component="th" scope="row" sx={{ fontSize:"12px",fontWeight:400,color:'var(--grey-variation-tablerowsLK)',paddingTop:"5px",paddingBottom:"5px"}}><Button sx={{padding:"0px",fontSize:"16px",fontFamily:"Roboto",textTransform:'capitalize', backgroundColor:"var(--SecondaryBackground)", borderRadius:"20px", boxShadow: "none",paddingLeft:0}} variant="text" onClick={() => handleEdit(currentDashboard)} disableTouchRipple elevation={0}><LK_Edit color={"#005C8E"} width={"17px"} height={"17px"}/></Button></TableCell>
                                    <TableCell component="th" scope="row" sx={{ fontSize:"12px",fontWeight:400,color:'var(--grey-variation-tablerowsLK)',paddingTop:"5px",paddingBottom:"5px"}}><Button sx={{padding:"0px",fontSize:"16px",fontFamily:"Roboto",textTransform:'capitalize', backgroundColor:"var(--SecondaryBackground)", borderRadius:"20px", boxShadow: "none",paddingLeft:0}} variant="text" onClick={() => handleDelete(currentDashboard)} disableTouchRipple elevation={0}><LK_Delete color={"#005C8E"} width={"25px"} height={"25px"}/></Button></TableCell>
                                </TableRow>
                            )): <Typography sx={{fontSize:"16px",fontFamily:"Roboto",color:'var(--SecondaryText)',fontWeight: 400, marginLeft:"0px",marginTop:"6px", textAlign:"left"}}>No Dashboards Found</Typography>}
                        </TableBody>
                    </Table>
                </TableContainer>) 
                :<Box sx={{display:'flex',justifyContent:'center',alignItems:'center',boxSizing:"border-box",height:'calc(100% - 40px)',width:'100%'}} >
                  <img src={LK_Loading} alt="loading..." style={{height:"60px" ,width:"auto"}} />
              </Box>}
            </>}
             {
                (editMode == true) && 
                <>
                    <Box  sx={{padding:"0px",width:"100%" ,boxSizing:"border-box"}} >
                        <Box  sx={{padding:"0px",width:'100%',height:"7%" ,boxSizing:"border-box",display:"flex",gap:'8px'}} >
                            <Box sx={{flexGrow:1}}></Box>
                            <CustomButton /*id={assetInfo.id} */ onClick={handleSaveUpdatedChange} buttonText={'Save'} width={'12px'} />
                            <CustomCancelButton  onClick={handleCancelUpdatedChange}  buttonText={'Cancel'}></CustomCancelButton>
                        </Box>
                        <div style={{display:'flex', flexDirection:'row',gap:"40px"}}>
                            <div style={{marginTop:"65px"}}>
                                    {/* Asset Tags Retrieval Component */}
                                <AssetTagsRetrievalModified 
                                    assetdata={assetdata} 
                                    setExistingDeviceTagAlarmConfig={setExistingDeviceTagAlarmConfig} 
                                    setSelectedTag={setSelectedTag} 
                                    selectedTag={selectedTag}
                                    setSelectedAsset={setSelectedAsset} 
                                    setShowAliasFlag={setShowAliasFlag}
                                />
                            </div>
                           <div style={{ padding: '24px', paddingRight: '12px', maxWidth: '1400px', margin: '0 auto', fontFamily: 'Arial, sans-serif', overflowY: 'auto', height: '85vh' }}>
                              <Typography sx={{fontSize:"16px",fontFamily:"Roboto",color:'var(--SecondaryText)',fontWeight: 400, marginLeft:"0px",textAlign:"left",marginTop:"10px"}}>
                                  Edit Energy Dashboard Configuration: {formConfig.formName || 'Not set'}
                              </Typography>

                              {/* Energy Tag Configuration */}
                              <div style={{ marginBottom: '30px' }}>
                                  <Typography sx={{fontSize:"16px",fontFamily:"Roboto",color:'var(--SecondaryText)', marginBottom: '15px',fontWeight: 400, marginLeft:"0px",marginTop:"6px", textAlign:"left"}}>Energy Tag Configuration</Typography>
                                  {renderEnergyTagField()}
                              </div>

                              {/* Main Content Layout */}
                              <div style={{ display: 'flex', flexDirection: 'row', gap: '40px', overflowY: 'auto', maxHeight: 'calc(85vh - 500px)', paddingRight: '8px' }}>
                          
                                  <div style={{ flex: 1 }}>
                                      {/* Render Parameter Configuration Fields */}
                                      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '30px' }}>
                                          <div>
                                              {renderXParameterFields()}
                                          </div>
                                          <div>
                                              {renderYParameterFields()}
                                          </div>
                                      </div>
                                  </div>
                              </div>

                          </div>
                        </div>
                        <CustomDialogBox dialogTitle={"Updated Dashboard Successfully"} dialogText={"Dashboard Successfully updated "}  openDialog={createdSucess}  handleCloseDialog={handleCloseCreateDashboard}  handleConfirmDialog={handleCloseCreateDashboard}  confirmText={"Ok"}  cancelText={"Cancel"} type={"Success"}/>
                        <CustomDialogBox dialogTitle={"Updated Dashboard Failed"} dialogText={"Failed to update dashboard .Try Again! "}  openDialog={notCreatedSuccess}  handleCloseDialog={handleCloseNotCreateDashboard}  handleConfirmDialog={handleCloseNotCreateDashboard}  confirmText={"Ok"}  cancelText={"Cancel"} type={"Error"}/>
                    </Box>
                </>
            }

            <CustomDialogBox dialogTitle={"Delete Dashboard"} dialogText={"Are you sure you want to delete "}  openDialog={deleteMode}  handleCloseDialog={handleCloseDeleteDashboard}  handleConfirmDialog={handleConfirmDialogDeleteDashboard}  confirmText={"Yes"}  cancelText={"No"} type={""}/>
            {/* <CustomDialogBox dialogTitle={"Delete Dashboard"} dialogText={"Are you sure you want to delete "}  openDialog={deleteMode}  handleCloseDialog={handleCloseDeleteDashboard}  handleConfirmDialog={handleConfirmDialogDeleteDashboard}  confirmText={"Yes"}  cancelText={"No"} type={""}/> */}
            <CustomDialogBox dialogTitle={"Delete Dashboard Failed"} dialogText={notCreatedMessage || "Failed to delete dashboard .Try Again! "}  openDialog={deleteDashboardFailed}  handleCloseDialog={handleCloseDeleteDashboardFailed}  handleConfirmDialog={handleCloseDeleteDashboardFailed}  confirmText={"Ok"}  cancelText={"Cancel"} type={"Error"}/>
             <CustomDialogBox dialogTitle={"Delete Dashboard Success"} dialogText={"Dashboard Successfully deleted "}  openDialog={deleteDashboardSuccess}  handleCloseDialog={handleCloseDeleteDashboardSuccess}  handleConfirmDialog={handleCloseDeleteDashboardSuccess}  confirmText={"Ok"}  cancelText={"Cancel"} type={"Success"}/>
            <CustomDialogBox dialogTitle={"Updated Dashboard Successfully"} dialogText={"Dashboard Successfully updated "}  openDialog={updatedSucess}  handleCloseDialog={handleCloseUpdateDashboard}  handleConfirmDialog={handleCloseUpdateDashboard}  confirmText={"Ok"}  cancelText={"Cancel"} type={"Success"}/>
            <CustomDialogBox dialogTitle={"Updated Dashboard Failed"} dialogText={notCreatedMessage || "Failed to update dashboard .Try Again! "}  openDialog={notupdatedSucess}  handleCloseDialog={handleCloseNotUpdateDashboard}  handleConfirmDialog={handleCloseNotUpdateDashboard}  confirmText={"Ok"}  cancelText={"Cancel"} type={"Error"}/>

        </Box>
        
            
    )
}